import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLayoutStore = defineStore('layout', () => {
  const chromeVisible = ref(true)

  function toggleChrome() {
    chromeVisible.value = !chromeVisible.value
  }

  function setChromeVisible(visible: boolean) {
    chromeVisible.value = visible
  }

  return {
    chromeVisible,
    toggleChrome,
    setChromeVisible,
  }
})
